import { Alert } from '@mui/material';
import { useEffect, useState } from 'react';

type Props = {
  error: any;
  onClose?: () => void;
};
const ErrorMessage = ({ error, onClose }: Props) => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!error) {
      setMessage('');
      return;
    }
    if (typeof error === 'string') {
      setMessage(error);
      return;
    }
    const responseError =
      error.response?.data?.error ||
      error.response?.data?.message ||
      (error.response?.data?.items &&
        error.response?.data?.items.find((i: any) => i.error)?.error);
    const { errorCode, message: msg, httpCode, error: errDetail } = error;
    if (responseError) {
      setMessage(typeof responseError === 'string' ? responseError : JSON.stringify(responseError));
    } else if (errDetail) {
      setMessage(typeof errDetail === 'string' ? errDetail : JSON.stringify(errDetail));
    } else if (msg) {
      setMessage(msg);
    } else if (errorCode) {
      setMessage(`An error occured. Error code: ${errorCode}`);
    } else if (httpCode) {
      setMessage(`An error occured. Http code: ${httpCode}`);
    } else {
      setMessage(`An error occured.`);
    }
  }, [error]);

  return (
    <Alert severity="error" onClose={onClose} sx={{ pb: 0, pt: 0 }}>
      {message}
    </Alert>
  );
};

export default ErrorMessage;
